module.exports = __webpack_public_path__ + "img/20220720113958.a538323f.gif";